import { render } from "./ReportRegulator.vue?vue&type=template&id=3c5ac78d"
import script from "./ReportRegulator.vue?vue&type=script&lang=js"
export * from "./ReportRegulator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__